import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import minusIcon from '../assets/images/sidebar-minus-icon.svg'
import plusIcon from '../assets/images/sidebar-plus-icon.svg'
import Scrollspy from 'react-scrollspy'

const Container = styled.div`
  background: #f3f4f8;
  ${props => `
    padding: ${props.padding || '0'};
    margin: ${props.margin || '0'};
    max-width: ${props.maxWidth || '300px'};
  `};
`

const LinkContainer = styled.div`
  display: flex;
  cursor: pointer;

  img {
    margin: 0 0 0 auto;
  }
`

const Link = styled.a`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
  color: #1a2f77;

  ${props =>
    props.active
      ? `
  color: #1670da;

  &:before {
    content: '•';
    color: #1670da;
    padding: 0 12px;
  }`
      : ``}
`

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: ${props => props.margin || '0'};
  position: sticky;
  top: 40px;

  a:hover {
    text-decoration: none;
  }
`

const SubLinksContainer = styled(InnerContainer)`
  max-height: 253px;
  overflow: scroll;
  margin-left: ${props => (props.active ? '31px' : '0')};
`

const SubLink = styled.a`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #1a2f77;
  cursor: pointer;
`

const SubLinksCounter = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #1a2f77;
  background: #e5e5e5;
  border-radius: 999px;
  padding: 3px 8px;
`

const Sidebar = ({ options, maxWidth }) => {
  const [openSubLinks, setOpenSubLinks] = useState(null)
  const [activeOption, setActiveOption] = useState(null)

  return (
    <Container maxWidth={maxWidth} padding="40px 16px 40px 6px" className="sidebar">
      <Scrollspy
        items={options.map(opt => opt.to.replace('#', ''))}
        componentTag={InnerContainer}
        onUpdate={e => setActiveOption(`#${e?.id}`)}
        currentClassName=""
      >
        {options?.map(option => {
          const optionKey = `${option.to}-${option.label}`
          const hasSubOptionsCollapsed = openSubLinks === optionKey
          const isActive = activeOption === option.to

          return (
            <InnerContainer key={optionKey} margin={isActive ? '0' : '0 0 0 31px'}>
              <LinkContainer>
                <Link href={option.to} active={isActive}>
                  <span>
                    {option.label}{' '}
                    {option.subOptions?.length ? (
                      <SubLinksCounter>{option.subOptions.length}</SubLinksCounter>
                    ) : null}
                  </span>
                </Link>
                {option.subOptions?.length ? (
                  <img
                    src={hasSubOptionsCollapsed ? minusIcon : plusIcon}
                    alt={hasSubOptionsCollapsed ? 'Collapse' : 'Expand'}
                    onClick={() => setOpenSubLinks(!hasSubOptionsCollapsed ? optionKey : null)}
                  />
                ) : null}
              </LinkContainer>
              {hasSubOptionsCollapsed && option.subOptions ? (
                <SubLinksContainer active={isActive}>
                  {option.subOptions.map(option => (
                    <SubLink href={option.to} key={`${option.to}-${option.label}`}>
                      {option.label}
                    </SubLink>
                  ))}
                </SubLinksContainer>
              ) : null}
            </InnerContainer>
          )
        })}
      </Scrollspy>
    </Container>
  )
}

Sidebar.propTypes = {
  options: PropTypes.array,
  maxWidth: PropTypes.string,
}

export default Sidebar
